import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid,
  Paper,
  Typography,
  TextField,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TableHead,
  Select as MaterialUISelect,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import Select from '../../components/controls/Select';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { getLedgerList, getLedgerExcel } from '../../services/ledger';
import { getDistributorList, getSpecificDistributor } from '../../services/distributorService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { lighten, makeStyles } from '@material-ui/core/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { getCurrentUser } from '../../services/userService';
import { formatDate } from '../../helpers/helperFunctions';
import { USER_TYPES } from '../../constants';
import { getDistributorsForSalesPersons } from '../../services/salesPersonService';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 5.5 + ITEM_PADDING_TOP,
      width: 400,
    },
  },
};

function createData(row) {
  return {
    DOC_DT: row['DOC_DT'],
    POS_DT: row['POS_DT'],
    DOC_NO: row['DOC_NO'],
    ASS_DATA: row['ASS_DATA'],
    BILL_NO: row['BILL_NO'],
    DESCR: row['DESCR'],
    CR_AMT: row['CR_AMT'],
    DR_AMT: row['DR_AMT'],
    CURR: row['CURR'],
    CR_DT_TXT: row['CR_DT_TXT'],
    Text: row['Text'],
    KUNNR: row['KUNNR'],
    CLS_BAL: row['CLS_BAL'],
  };
}

const formatAmount = (val) => {
  const num = Number(val);
  if (isNaN(num)) {
    return val;
  }
  return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
const cssStyles = (theme) => ({
  pageContent: {
    // margin: theme.spacing(5),
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
  container: {
    display: 'block',
    maxWidth: '85vw',
    overflowX: 'auto',
    marginRight: 'auto',
    marginLeft: 'auto',
    padding: '2px',
    margin: '5px',
    fontSize: '12px',
  },
  textDark: {
    fontWeight: '500',
    fontSize: '15px',
    lineHeight: '18px',
    color: '#323232',
    opacity: '0.99',
  },
});
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'Doc.Date',
    numeric: false,
    disablePadding: false,
    label: 'Doc.Date',
  },
  // {
  //   id: "Posting Date",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Posting Date",
  // },
  { id: 'Doc.No.', numeric: true, disablePadding: false, label: 'Doc.No.' },
  { id: 'KUNNR', numeric: false, disablePadding: false, label: 'Distributor' },
  { id: 'Ass._Data', numeric: true, disablePadding: false, label: 'Ass._Data' },
  {
    id: 'Billing Doc',
    numeric: false,
    disablePadding: false,
    label: 'Billing Doc',
  },
  {
    id: 'Description',
    numeric: false,
    disablePadding: false,
    label: 'Description',
  },
  {
    id: 'Credit Amount',
    numeric: true,
    disablePadding: false,
    label: 'Credit Amount',
  },
  {
    id: 'Debit Amount',
    numeric: true,
    disablePadding: false,
    label: 'Debit Amount',
  },

  {
    id: 'Currency',
    numeric: false,
    disablePadding: false,
    label: 'Currency',
  },
  {
    id: 'Credit/Debit',
    numeric: false,
    disablePadding: false,
    label: 'Credit/Debit',
  },
  {
    id: 'CLS_BAL',
    numeric: true,
    disablePadding: false,
    label: 'Closing Balance',
  },
];

function EnhancedTableHead(props) {
  const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    // minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  pageContent: {
    // margin: theme.spacing(3),
    padding: theme.spacing(1),
  },
  toolbar: theme.mixins.toolbar,

  textCenter: {
    textAlign: 'center',
  },
  container: {
    display: 'block',
    maxWidth: '85vw',
    overflowX: 'auto',
    marginRight: 'auto',
    marginLeft: 'auto',
    padding: '10px',
    margin: '10px',
  },
}));

const LedgerList = (props) => {
  const history = useHistory();
  const [state, setState] = useState({
    rows: [],
    stableData: [],
  });

  const classes = useStyles();
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('date');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const [user, setUser] = useState();
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(false);
  const [distributors, setDistributors] = useState([]);
  const [distributorId, setDistributorId] = useState();
  const [distributorSelected, setDistributorSelected] = useState(-1);
  const [downloading, setDownloading] = useState(false);

  const getFinancialYearRange = () => {
    const now = moment();
    const fyStartYear = now.month() >= 3 ? now.year() : now.year() - 1;
    return {
      start: moment(`${fyStartYear}-04-01`).format('YYYY-MM-DD'),
      end: moment.min(moment(`${fyStartYear + 1}-03-31`), moment()).format('YYYY-MM-DD'),
    };
  };
  const { start, end } = getFinancialYearRange();
  const [start_date, setStartDate] = useState(start);
  const [end_date, setEndDate] = useState(end);

  const filterColumn = 'DOC_DT';

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    funcGetDispatchOrderList(distributorSelected, newPage, rowsPerPage, start_date, end_date);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    funcGetDispatchOrderList(distributorSelected, 0, newRowsPerPage, start_date, end_date);
  };

  const getCurrentUserFunc = async () => {
    setLoading(true);
    const user = await getCurrentUser();
    console.log('user', user);
    if (user && user.data) {
      setCurrentUser(user.data.body);
      if (user.data.body.user_type !== 'admin') {
        setDistributorId(user.data.body.org_id);
      }
      return user.data.body;
    }
    return null;
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, state.rows.length);

  const funcGetDispatchOrderList = async (
    filterStatus = distributorSelected,
    currentPage = page,
    currentRowsPerPage = rowsPerPage,
    startDate = start_date,
    endDate = end_date
  ) => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: currentRowsPerPage,
      };
      if (filterStatus !== -1 && filterStatus !== "-1") {
        params.kunnr = filterStatus;
      }
      if (startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      }

      const DispatchOrderList = await getLedgerList(params);
      const resData = DispatchOrderList.data?.data || {};
      const poList = resData.data || [];
      const total = resData.totalCount !== undefined ? resData.totalCount : poList.length;

      setUser(DispatchOrderList.data?.user);

      const stableData = poList.map(createData);

      setDistributorSelected(filterStatus);
      setTotalCount(total);
      setState({ rows: stableData, stableData: stableData });
    } catch (err) {
      console.error("Error fetching ledger list:", err);
      history.push('/');
    }
    setLoading(false);
  };

  const distributorsList = async (userBody) => {
    var distLists;
    var dLists;
    if (userBody?.user_type === 'admin') {
      distLists = await getDistributorList();
      dLists = distLists.data.data;
    } else if (userBody?.user_type === USER_TYPES.SALES_PERSON) {
      distLists = await getDistributorsForSalesPersons(userBody.id);
      dLists = distLists;
    } else if (userBody) {
      distLists = await getSpecificDistributor();
      dLists = distLists.data.data;
    } else {
      return;
    }
    let distributorsArray = [];
    let distributorVal = {};
    for (let [key, value] of dLists.entries()) {
      distributorsArray.push({
        sap_distributor_code: value.sap_distributor_code,
        title: value.org_name || value.title || value.sap_distributor_code
      });
      distributorVal = value;
    }
    setDistributors(distributorsArray);
    setDistributorId(userBody?.user_type === 'admin' ? distributorId : distributorVal.id);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const userBody = await getCurrentUserFunc();
        await distributorsList(userBody);
        await funcGetDispatchOrderList(-1, 0, rowsPerPage, start, end);
      } catch (err) {
        history.push('/');
        return;
      }
      setLoading(false);
    };
    init();
  }, []);

  const handleDistributorChange = (org_id) => {
    let distributorId;
    if (org_id) {
      distributorId = org_id;
    }
    setDistributorId(distributorId);
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const downloadExcel = async () => {
    setDownloading(true);
    const params = {};
    if (distributorSelected !== -1 && distributorSelected !== "-1") {
      params.kunnr = distributorSelected;
    }
    if (start_date && end_date) {
      params.start_date = start_date;
      params.end_date = end_date;
    }
    try {
      let contractData = await getLedgerExcel(params);
      const base64string = contractData.data;
      const contenttype = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      var file = b64toBlob(base64string, contenttype);
      var a = document.createElement('a');
      a.href = window.URL.createObjectURL(file);
      a.target = '_blank';
      a.download = 'Ledger-' + new Date().toDateString() + '.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.error('Error downloading excel:', err);
    }
    setDownloading(false);
  };

  const handleChangeDate = (e) => {
    let newStartDate = start_date;
    let newEndDate = end_date;

    if (e.target.name === 'end_date') {
      setEndDate(e.target.value);
      newEndDate = e.target.value;
    } else if (e.target.name === 'start_date') {
      setStartDate(e.target.value);
      newStartDate = e.target.value;
    }

    // const from = moment(newStartDate, 'YYYY-MM-DD').startOf('day');
    // const to = moment(newEndDate, 'YYYY-MM-DD').endOf('day');

    // var resultProductData = state.stableData.filter(function (a) {
    //   const check = moment(a[filterColumn]);
    //   return check.isBetween(from, to, null, '[]');
    // });

    // console.log('result', resultProductData);
    // setState((previousState) => ({
    //   ...previousState,
    //   rows: resultProductData,
    // }));
  };

  return (
    <main className={classes.pageContent}>
      <div className={classes.toolbar} />
      <div style={{ marginBottom: '25px', marginTop: '10px' }}>
        <Grid container justify="space-between" spacing={2}>
          <Grid item container xs={12} sm={6} md={6} lg={6} spacing={1}>
            <Typography variant="h6" style={{ marginBottom: '10px' }}>
              Ledger List
            </Typography>
          </Grid>
          {currentUser && (
            <>
              {' '}
              {currentUser.status === 1 && (
                <Grid>
                  <Button color="primary" variant="contained" onClick={() => downloadExcel()}>
                    {downloading ? <CircularProgress disableShrink color="white" /> : 'Download'}
                  </Button>
                </Grid>
              )}
            </>
          )}
        </Grid>
      </div>
      <div className={classes.root}>
        <Paper className={classes.container}>
          <Grid container justify="space-between">
            <Grid style={{ textAlign: 'left', marginBottom: '8px' }} item md={6} xs={6}>
              {currentUser?.user_type !== USER_TYPES.DISTRIBUTOR && (
                <Autocomplete
                  id="distributor-search"
                  options={distributors}
                  getOptionLabel={(option) => option.title || ""}
                  value={distributors.find(d => d.sap_distributor_code === distributorSelected) || null}
                  onChange={(event, newValue) => {
                    const selectedKunnr = newValue ? newValue.sap_distributor_code : -1;
                    setDistributorSelected(selectedKunnr);
                    setPage(0);
                    funcGetDispatchOrderList(selectedKunnr, 0, rowsPerPage, start_date, end_date);
                  }}
                  disabled={currentUser?.user_type === USER_TYPES.DISTRIBUTOR ? true : false}
                  renderInput={(params) => (
                    <TextField {...params} label="Search Distributor" variant="outlined" />
                  )}
                  style={{ marginTop: '5px', minWidth: '300px' }}
                />
              )}
            </Grid>
            <Grid style={{ textAlign: 'right' }} item md={6} xs={6}>
              <TextField
                style={{ marginRight: '1em' }}
                name="start_date"
                label="Start Date"
                type="date"
                required
                value={moment(start_date).format('yyyy-MM-DD')}
                onChange={handleChangeDate}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                name="end_date"
                label="End Date"
                type="date"
                required
                style={{ marginRight: '20px', marginBottom: '12px' }}
                value={moment(end_date).format('yyyy-MM-DD')}
                onChange={handleChangeDate}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <Button
                color="primary"
                variant="contained"
                disabled={loading}
                onClick={() => {
                  setPage(0);
                  funcGetDispatchOrderList(distributorSelected, 0, rowsPerPage, start_date, end_date);
                }}
              >
                Filter
              </Button>
            </Grid>
          </Grid>

          <hr />
          {loading === false ? (
            <>
              {' '}
              <TableContainer style={{ textAlign: 'center' }}>
                <Table className={classes.table} aria-labelledby="tableTitle" size="medium" aria-label="enhanced table">
                  <EnhancedTableHead
                    classes={classes}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={state.rows.length}
                  />
                  <TableBody>
                    {stableSort(state.rows, getComparator(order, orderBy))
                      .map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow hover role="checkbox" tabIndex={-1} key={row.id || index}>
                            <TableCell align="right">{formatDate(row['DOC_DT'])}</TableCell>
                            <TableCell align="right">{row['DOC_NO']}</TableCell>
                            <TableCell align="right">{row['KUNNR']}</TableCell>
                            <TableCell align="right">{row['ASS_DATA']}</TableCell>
                            <TableCell align="right">{row['BILL_NO']}</TableCell>
                            <TableCell align="left">{row['DESCR']}</TableCell>
                            <TableCell align="right">{formatAmount(row['CR_AMT'])}</TableCell>
                            <TableCell align="right">{formatAmount(row['DR_AMT'])}</TableCell>
                            <TableCell align="right">{row['CURR']}</TableCell>
                            <TableCell align="right">{row['CR_DT_TXT']}</TableCell>
                            <TableCell align="left">{formatAmount(row['CLS_BAL'])}</TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={11} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </>
          ) : (
            <>
              <CircularProgress />
            </>
          )}
        </Paper>
      </div>
    </main>
  );
};

export default withStyles(cssStyles)(LedgerList);
